export const productObjectArray = [
  {
    img:
    window.location.origin + '/imgs/StadiumLeggings.jpeg',
    brand: 'Nike',
    name: 'Stadium Full Length Leggings',
    sale_price: '44.00',
    origin_price: '80.00',
    id: '1',
    tags: ['leggings', 'black']
  },
  {
    img:
    window.location.origin + '/imgs/EnergizeBra.jpeg',
    brand: 'Nike',
    name: 'Energize Bra',
    sale_price: '40.00',
    origin_price: '88.00',
    id: '2',
    tags: ['bra', 'blue']
  },
  {
    img:
    window.location.origin + '/imgs/EnergizeLeggings.jpeg',
    brand: 'Nike',
    name: 'Energize Full Length Leggings',
    sale_price: '48.00',
    origin_price: '70.00',
    id: '3',
    tags: ['leggings', 'black']
  },
  {
    img:
    window.location.origin + '/imgs/StadiumBra.jpeg',
    brand: 'Nike',
    name: 'Stadium Bra',
    sale_price: '45.00',
    origin_price: '65.00',
    id: '4',
    tags: ['bra', 'white']
  },
  {
    img:
    window.location.origin + '/imgs/OhBoyTee.jpeg',
    brand: 'Nike',
    name: 'Oh Boy Tee',
    sale_price: '45.00',
    origin_price: '65.00',
    id: '5',
    tags: ['tee', 'white']
  },
  {
    img:
    window.location.origin + '/imgs/PerfTank.jpeg',
    brand: 'Nike',
    name: 'Perf Tank',
    sale_price: '45.00',
    origin_price: '65.00',
    id: '6',
    tags: ['tank', 'black']
  },
  {
    img:
    window.location.origin + '/imgs/StadiumLeggings.jpeg',
    brand: 'Nike',
    name: 'Stadium Full Length Leggings',
    sale_price: '44.00',
    origin_price: '80.00',
    id: '1',
    tags: ['leggings', 'black']
  },
  {
    img:
    window.location.origin + '/imgs/EnergizeBra.jpeg',
    brand: 'Nike',
    name: 'Energize Bra',
    sale_price: '40.00',
    origin_price: '88.00',
    id: '2',
    tags: ['bra', 'blue']
  },
  {
    img:
    window.location.origin + '/imgs/EnergizeLeggings.jpeg',
    brand: 'Nike',
    name: 'Energize Full Length Leggings',
    sale_price: '48.00',
    origin_price: '70.00',
    id: '3',
    tags: ['leggings', 'black']
  },
  {
    img:
    window.location.origin + '/imgs/StadiumBra.jpeg',
    brand: 'Nike',
    name: 'Stadium Bra',
    sale_price: '45.00',
    origin_price: '65.00',
    id: '4',
    tags: ['bra', 'white']
  },
  {
    img:
    window.location.origin + '/imgs/OhBoyTee.jpeg',
    brand: 'Nike',
    name: 'Oh Boy Tee',
    sale_price: '45.00',
    origin_price: '65.00',
    id: '5',
    tags: ['tee', 'white']
  },
  {
    img:
    window.location.origin + '/imgs/PerfTank.jpeg',
    brand: 'Nike',
    name: 'Perf Tank',
    sale_price: '45.00',
    origin_price: '65.00',
    id: '6',
    tags: ['tank', 'black']
  },
  {
    img:
    window.location.origin + '/imgs/StadiumLeggings.jpeg',
    brand: 'Nike',
    name: 'Stadium Full Length Leggings',
    sale_price: '44.00',
    origin_price: '80.00',
    id: '1',
    tags: ['leggings', 'black']
  },
  {
    img:
    window.location.origin + '/imgs/EnergizeBra.jpeg',
    brand: 'Nike',
    name: 'Energize Bra',
    sale_price: '40.00',
    origin_price: '88.00',
    id: '2',
    tags: ['bra', 'blue']
  },
  {
    img:
    window.location.origin + '/imgs/EnergizeLeggings.jpeg',
    brand: 'Nike',
    name: 'Energize Full Length Leggings',
    sale_price: '48.00',
    origin_price: '70.00',
    id: '3',
    tags: ['leggings', 'black']
  },
  {
    img:
    window.location.origin + '/imgs/StadiumBra.jpeg',
    brand: 'Nike',
    name: 'Stadium Bra',
    sale_price: '45.00',
    origin_price: '65.00',
    id: '4',
    tags: ['bra', 'white']
  },
  {
    img:
    window.location.origin + '/imgs/OhBoyTee.jpeg',
    brand: 'Nike',
    name: 'Oh Boy Tee',
    sale_price: '45.00',
    origin_price: '65.00',
    id: '5',
    tags: ['tee', 'white']
  },
  {
    img:
    window.location.origin + '/imgs/PerfTank.jpeg',
    brand: 'Nike',
    name: 'Perf Tank',
    sale_price: '45.00',
    origin_price: '65.00',
    id: '6',
    tags: ['tank', 'black']
  },
  {
    img:
    window.location.origin + '/imgs/StadiumLeggings.jpeg',
    brand: 'Nike',
    name: 'Stadium Full Length Leggings',
    sale_price: '44.00',
    origin_price: '80.00',
    id: '1',
    tags: ['leggings', 'black']
  },
  {
    img:
    window.location.origin + '/imgs/EnergizeBra.jpeg',
    brand: 'Nike',
    name: 'Energize Bra',
    sale_price: '40.00',
    origin_price: '88.00',
    id: '2',
    tags: ['bra', 'blue']
  },
  {
    img:
    window.location.origin + '/imgs/EnergizeLeggings.jpeg',
    brand: 'Nike',
    name: 'Energize Full Length Leggings',
    sale_price: '48.00',
    origin_price: '70.00',
    id: '3',
    tags: ['leggings', 'black']
  },
  {
    img:
    window.location.origin + '/imgs/StadiumBra.jpeg',
    brand: 'Nike',
    name: 'Stadium Bra',
    sale_price: '45.00',
    origin_price: '65.00',
    id: '4',
    tags: ['bra', 'white']
  },
  {
    img:
    window.location.origin + '/imgs/OhBoyTee.jpeg',
    brand: 'Nike',
    name: 'Oh Boy Tee',
    sale_price: '45.00',
    origin_price: '65.00',
    id: '5',
    tags: ['tee', 'white']
  },
  {
    img:
    window.location.origin + '/imgs/PerfTank.jpeg',
    brand: 'Nike',
    name: 'Perf Tank',
    sale_price: '45.00',
    origin_price: '65.00',
    id: '6',
    tags: ['tank', 'black']
  }
];
